import { APP_DATE_FORMAT } from "@/config/constants";
import { IEdoChatMessage } from "@/shared/model/edo-chat-message.model";
import { TextFormat } from "react-jhipster";

export interface MyMessageProps {
  messaggio: IEdoChatMessage;
}

export const MyMessage = (props: MyMessageProps) => {
  const { messaggio } = props;

  return (
    <div className="flex flex-col items-end">
      <p className="text-sm text-[var(--color-mockup-text)]">{messaggio.message}</p>
      <span className="text-xs text-[var(--color-mockup-text-light)]">
        <TextFormat
          type="date"
          value={messaggio.createdAt}
          format={APP_DATE_FORMAT}
          locale="it"
        />
      </span>
    </div>
  );
};
